export const facebookStatisticsFilters = [
  {
    label: 'Популярные',
    options: [
      {value: 'advertiser_id', label: 'Рекламодатель'},
      {value: 'offer_id', label: 'Оффер'},
      {value: 'app_id', label: 'Приложения'},
      {value: 'bayer_id', label: 'Байер'},
      {value: 'state', label: 'Состояние'},
    ],
  },
  {
    label: 'Рекламодатель',
    options: [
      {value: 'advertiser_id', label: 'Рекламодатель'},
      {value: 'offer_id', label: 'Оффер'},
      {value: 'landing_id', label: 'Лендинг'},
      {value: 'brand_id', label: 'Бренд'},
    ],
  },
  {
    label: 'Influence',
    options: [
      {value: 'app_id', label: 'Приложения'},
      {value: 'bayer_id', label: 'Байер'},
      {value: 'inf_traffic_id', label: 'Блогер'},
      {value: 'link_id', label: 'Поток'},
      {value: 'app_service_id', label: 'Сервисы', isSearch: false},
      {value: 'app_type', label: 'Типы приложений'},
      {value: 'traffic_type', label: 'Типы трафика'},
    ],
  },
  {
    label: 'Состояние',
    options: [
      {value: 'state', label: 'Состояние'},
      {value: 'traffic_type', label: 'Типы трафика'},
    ],
  },
  {
    label: 'Страна',
    options: [{value: 'country_id', label: 'Страна'}],
  },
];
